import React from 'react';
import * as PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import { t } from '../../../../utils/i18next';
import SystemButton from '../SystemButton';
import GeneralPaymentErrorText from '../paymentInformation/GeneralPaymentErrorText/GeneralPaymentErrorText';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
  Divider,
  Paper
} from '@mui/material';

const translationsBase = 'payment_flow.payment_summary';
const translationsPayment = `${translationsBase}.payment`;

const OneClickPaymentDialog = ({
  open,
  paymentDetails,
  isSubmitting,
  showError,
  handleClose,
  submitPayment
}) => {
  const { amount, date, balance, cardEnding } = paymentDetails;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 1
          }}
        >
          <Box component="span" sx={{ fontSize: 40, mr: 1 }}>
            💳
          </Box>
        </Box>
        {t(`${translationsBase}.dialog_title`)}
      </DialogTitle>
      <IconButton
        aria-label="close"
        data-testid={'close-button'}
        sx={{ position: 'absolute', right: 0 }}
        onClick={() => handleClose()}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ padding: '0 2rem 0 2rem' }}>
        <Typography align="center" sx={{ mb: 2 }}>
          {t(`${translationsBase}.dialog_subtitle`)}
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Paper elevation={3} sx={{ p: 2, mb: 2 }}>
          <Box display="flex" justifyContent="space-between" sx={{ mb: 1 }}>
            <Typography>
              {t(`${translationsPayment}.payment_amount`)}
            </Typography>
            <Typography variant="subtitle2">{`$${amount}`}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" sx={{ mb: 1 }}>
            <Typography>{t(`${translationsPayment}.payment_date`)}</Typography>
            <Typography variant="subtitle2">{date}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between" sx={{ mb: 1 }}>
            <Typography>
              {t(`${translationsPayment}.account_balance`)}
            </Typography>
            <Typography variant="subtitle2">{`$${balance}`}</Typography>
          </Box>
          <Box display="flex" justifyContent="space-between">
            <Typography>{t(`${translationsBase}.payment_method`)}</Typography>
            <Typography variant="subtitle2">
              {t(`${translationsBase}.cc_ends_in`, { val: cardEnding })}
            </Typography>
          </Box>
        </Paper>
        {showError && <GeneralPaymentErrorText />}
      </DialogContent>
      <DialogActions>
        <SystemButton
          type="submit"
          color={'primary'}
          aria-label={'submit-button'}
          data-testid={'submit-button'}
          fullWidth={true}
          loading={isSubmitting}
          onClick={submitPayment}
        >
          {t('payment_flow.payment_confirmation.button')}
        </SystemButton>
      </DialogActions>
    </Dialog>
  );
};

OneClickPaymentDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  paymentDetails: PropTypes.object.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  showError: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  submitPayment: PropTypes.func.isRequired
};

export default OneClickPaymentDialog;
